import * as type from "../types";

export function getCollateralSucceeded(data) {
  return {
    type: type.GET_COLLATERALS_SUCCEEDED,
    payload: data,
  };
}

export function getCollateralRequested(reqParams) {
  return {
    type: type.GET_COLLATERALS_REQUESTED,
    payload: reqParams,
  };
}

export function setCollateralFilterDate(reqParams) {
  return {
    type: type.SET_COLLATERAL_FILTER_DATE,
    payload: reqParams,
  };
}

export function getCollateralFailed() {
  return {
    type: type.GET_COLLATERALS_FAILED,
  };
}

export function getInvoiceCollateralReportSucceeded(data) {
  return {
    type: type.GET_INVOICE_COLLATERAL_REPORT_SUCCEEDED,
    payload: data,
  };
}

export function getInvoiceCollateralReportRequested(reqParams) {
  return {
    type: type.GET_INVOICE_COLLATERAL_REPORT_REQUESTED,
    payload: reqParams,
  };
}

export function setInvoiceCollateralReportFilterDate(reqParams) {
  return {
    type: type.SET_INVOICE_COLLATERAL_REPORT_FILTER_DATE,
    payload: reqParams,
  };
}

export function getInvoiceCollateralReportFailed() {
  return {
    type: type.GET_INVOICE_COLLATERAL_REPORT_FAILED,
  };
}
